export function resolveCvReviewAdvanceTarget(input: {
  stage: string;
  status?: string | null;
  cvScore: number | null | undefined;
  defaultNext: string | null;
}): string | null {
  if (input.status === 'duplicate_review_pending' && input.cvScore == null) return input.defaultNext;
  if (input.stage === 'applied' && input.cvScore == null) return 'shortlisted';
  return input.defaultNext;
}
